import client from './api-client';

export const serviceGetDetalles = async (query) => {
    try {
        const response = await client.get(`detalles?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object

    } catch(error){
        throw error;
    }
}

export const serviceGetResponsablesAsignados = async (query) => {
    try {
        const response = await client.get(`proveedores-rol?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object

    } catch(error){
        throw error;
    }
}

export const serviceGetInforme = async (query) => {
    try {
        const response = await client.get(`descargas/movimientos-xls?q=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data

    } catch(error){
        throw error;
    }
}